import { mapGetters } from "vuex";
import { stringHelper } from "@/components/mixins/stringHelper";

export default {
  name: "MleContainerSummary",
  mixins: [stringHelper],
  props: {
    details: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapGetters(["getContentItem"]),
    containers(){
      return this.details.Containers;
    },
    carrierName(){
      return this.details.ShipViaDetails && this.details.ShipViaDetails.ShippingCarrierName;
    }
  },
  methods: {
    trackingNumber(container){
      var number = this.details.LineItems.filter(x => x.ContainerNumber === container)[0].CarrierTrackingNumber;
      return number;
    }
  }
};